import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d08dab9"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "profile-card-body" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 0,
  class: "subtitle"
}
const _hoisted_5 = {
  key: 1,
  class: "subtitle"
}
const _hoisted_6 = { class: "profile-action" }
const _hoisted_7 = {
  key: 0,
  class: "btn-highlight-label"
}
const _hoisted_8 = ["checked"]

import { computed } from 'vue'
import { genderImages, dottedPersonImage, Person } from '@/rd/ResearchDataModel'
import { usePersonStore } from '@/rd/PersonStore'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { useUserStore } from '@/gp/UserStore'
import { CompositeId } from '@/rd/CompositeId'
import { LoadMode } from '@/util/AsyncData'
import { ProfileUtils, ProfileType } from './profiles/ProfileUtils'
import { LinkIcon, LockIcon } from '@zhuowenli/vue-feather-icons'
import UserLink from '@/manage/users/UserLink.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileCard',
  props: {
    personId: {},
    selectMode: { type: Boolean },
    static: { type: Boolean },
    thisProfile: { type: Boolean },
    showProfileType: { type: Boolean },
    flat: { type: Boolean },
    showHover: { type: Boolean },
    disabled: { type: Boolean },
    dimmed: { type: Boolean },
    raised: { type: Boolean },
    highlightMode: { type: Boolean },
    highlighted: { type: Boolean },
    highlightSource: { type: Boolean },
    highlightSourceId: {}
  },
  emits: ["click", "highlight"],
  setup(__props: any, { emit }) {

const props = __props;





const personStore = usePersonStore()
const dataGroupStore = useDataGroupStore()
const userStore = useUserStore()

// Data loading
const personRef = computed(() => personStore.getAsyncPerson(props.personId, LoadMode.EnsureLoaded)?.data)
const displayPropsRef = computed(() => personRef.value?.displayProperties)
const dataGroupRef = computed(() => dataGroupStore.getAsyncGroup(CompositeId.getGroupId(props.personId), LoadMode.EnsureLoaded)?.data)
const ownerRef = computed(() => userStore.getAsyncUser(dataGroupRef.value?.ownerId, LoadMode.EnsureLoaded)?.data)

// Profile type
const profileTypeRef = computed(() => ProfileUtils.getProfileType(personRef.value, dataGroupRef.value, ownerRef.value))
const profileTypeTextRef = computed(() => ProfileUtils.getProfileSubtitle(profileTypeRef.value))

// Display state
const isEmptyRef = computed(() => !props.personId)
const isDanglingRef = computed(() => props.personId && personRef.value?.placeholder)
const isLinkableRef = computed(() => props.personId && personRef.value && !personRef.value.placeholder)

// Card content
const cardTitleRef = computed(() => 
  isEmptyRef.value ? '(none)' :
  isDanglingRef.value ? '(deleted or not visible)' : 
  displayPropsRef.value?.displayName ?? "(no name)"
)
const genderClassRef = computed(() => [displayPropsRef.value?.gender?.toLowerCase()])
const personImageUrlRef = computed(() => displayPropsRef.value?.primaryPhotoSignedUrl?.signedUrl)
const placeholderImageUrlRef = computed(() => 
  personRef.value?.restricted ? dottedPersonImage :
  !isLinkableRef.value ? dottedPersonImage :
  genderImages[displayPropsRef.value?.gender ?? "default"])
const personImageSrcRef = computed(() => personImageUrlRef.value ?? placeholderImageUrlRef.value)

const cardClassRef = computed(() => ({ 
  'this-profile': props.thisProfile,
  'restricted': personRef.value?.restricted,
  'empty': isEmptyRef.value,
  'dangling': isDanglingRef.value,
  'dimmed': props.dimmed,
  'flat': props.flat,
  'raised': props.raised,
  'show-hover': (isInteractiveRef.value && !props.flat) || props.showHover,
  'highlighted': props.highlightMode && props.highlighted
}))

const selectModeRef = computed(() => !props.static && props.selectMode && !isEmptyRef.value && !props.thisProfile && !props.disabled)
const linkModeRef = computed(() => !props.static && !props.selectMode && isLinkableRef.value && !props.thisProfile && !props.disabled)
const isInteractiveRef = computed(() => selectModeRef.value || linkModeRef.value)

const linkUrlRef = computed(() => linkModeRef.value ? Person.getPageUrl(props.personId) : undefined)

const isHighlightSourceRef = computed(() => props.highlightSource && props.highlightSourceId == props.personId)

function onClick(e: Event) {
  e.preventDefault()
  
  if (selectModeRef.value) {
    emit('click', props.personId)
  }
}

function onHighlightChange(e: Event) {
  const checkbox = e.target as HTMLInputElement
  emit('highlight', checkbox.checked ? props.personId : undefined)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["profile-card", cardClassRef.value])
  }, [
    (selectModeRef.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "overlay",
          onClick: onClick
        }))
      : _createCommentVNode("", true),
    (linkModeRef.value)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          to: linkUrlRef.value!,
          class: "overlay"
        }, null, 8, ["to"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["gender-bar", genderClassRef.value])
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["profile-card-image", { 'placeholder': !personImageUrlRef.value }])
    }, [
      _createElementVNode("img", { src: personImageSrcRef.value }, null, 8, _hoisted_1)
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(cardTitleRef.value), 1),
      (props.thisProfile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " (this profile) "))
        : (props.showProfileType)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (profileTypeRef.value == _unref(ProfileType).ManagedLinked)
                ? (_openBlock(), _createBlock(_unref(LinkIcon), {
                    key: 0,
                    size: "1x"
                  }))
                : _createCommentVNode("", true),
              (personRef.value?.restricted)
                ? (_openBlock(), _createBlock(_unref(LockIcon), {
                    key: 1,
                    size: "1x"
                  }))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(profileTypeTextRef.value) + " ", 1),
              (ownerRef.value)
                ? (_openBlock(), _createBlock(UserLink, {
                    key: 2,
                    userId: ownerRef.value?.id,
                    dimmed: "",
                    static: _ctx.static
                  }, null, 8, ["userId", "static"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.highlightMode && _ctx.highlightSource)
        ? (_openBlock(), _createElementBlock("label", _hoisted_7, [
            _createElementVNode("input", {
              type: "checkbox",
              class: "btn-highlight",
              checked: isHighlightSourceRef.value,
              onChange: onHighlightChange
            }, null, 40, _hoisted_8)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})